import { Opacity } from "@mui/icons-material";
import { Box, Menu } from "@mui/material";
import { styled as muiStyled } from '@mui/material/styles';
import { borderRadius, fontSize, fontWeight, height, lineHeight, textAlign } from "@mui/system";
import { thirdly2 } from "styles/theme";
import { dark } from "styles/theme";
import { thirdly } from "styles/theme";
import { bg } from "styles/theme";

export const SelectRoleStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    rowGap: 55,
    '.affiliation-name': {
        fontSize: 17,
        fontWeight: 200
    },
    '.role-cards': {
        display: "flex",
        columnGap: 15,
        flexWrap: "wrap",
        rowGap: 15
    },
    '.wrap-title': {
        display: "flex",
        justifyContent: "center",
        rowGap: 15,
        flexDirection: "column",
        alignItems: "center",
    },
    '.title': {
        fontWeight: "bold",
        fontSize: 22
    },
    '.sub-title': {
        fontSize: 18,
        textAlign: "center"
    },
    '.role-img': {
        width: 140,
        height: 140
    },
    '.select-button': {
        display: "none",
        // ':hover': {
        //     display: "block"
        // }
    },
    '.select-button:hover': {
        display: "block"
    },
    '.role-label': {
        fontSize: 20,
        fontWeight: "bold",
        textAlign: "center"
    },
    '.role-item': {
        width: 170,
        height: 240,
        borderRadius: 15,
        background: "white",
        display: "flex",
        flexDirection: "column",
        rowGap: 10,
        alignItems: "center",
        padding: 20,
        border: "1px solid transparent"
    },
    ".role-item:hover": {
        border: `1px solid ${thirdly}`
    },
    ".role-item:hover .select-role-btn": {
        display: "flex !important",
        position: "relative",
    },
}));

export const SelectRoleBtnStyles = muiStyled(Box)(({ }) => ({
    ".select-role": {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        width: "140px",
    },
    ".select-role-btn": {
        display: "none !important",
        position: "absolute",
    },
    ".role-item:hover .select-role-btn": {
        display: "flex !important",
        position: "relative",
    },
}));

export const RemoveRoleBtnStyles = muiStyled(Box)(({ }) => ({
    '.default-role': {
        '.MuiSvgIcon-root': {
            fontSize: 16
        },
        '.MuiButtonBase-root.MuiButton-root': {
            color: "#1577FF",
            background: "#CBE1FF",
            display: "flex",
            columnGap: 5,
            height: 25,
            fontSize: 15
        },
        display: "flex",
    },
}));

export const SelectRolePopupStyles = muiStyled(Box)(({ }) => ({
    zIndex: 1,
    width: 350,
    color: dark,
    borderRadius: 10,
    backgroundColor: "white",
    padding: 20,
    top: 185,
    left: 10,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: 15,
    '.logo-and-button': {
        display: "flex",
        flexDirection: 'row',
        alignItems: "center",
        columnGap: 10
    },
    ".role-item:hover .select-role-btn": {
        display: "flex !important",
        position: "relative",
    },
    '.header-logo': {
        width: 23,
        height: 23
    },
    '.wrap-heder-logo': {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 50,
        transform: 'translateZ(0px)',
        flexShrink: 0,
        width: 50,
        position: "relative",
        bottom: 40,
        left: 85,
        background: "white",
        borderRadius: 30
    },
    '.select-role': {
        fontSize: 14,
    },
    ".select-default-role": {
        color: "#26445A80"
    },
    '.affiliation-and-label': {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
    },
    '.role-label': {
        width: "100%",
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": "1",/* מספר השורות */
        overflow: "hidden",
        "text-overflow": "ellipsis"
    },
    '.role-details': {
        display: "flex",
        columnGap: 5,
        alignItems: "center",
        flexGrow: 1
    },
    '.remove-default-role': {
        display: "flex",
        marginTop: 10,
        columnGap: 10,
        width: "100%",
        ":hover": {
            opacity: 0.8,
            cursor: "pointer"
        }
    },
    '.role-items': {
        display: "flex",
        flexDirection: "column",
        rowGap: 7
    },
    '.role-item': {
        display: "flex",
        alignItems: "center",
        columnGap: 10,
        height: 42,
        padding: "2px 10px",
        border: `1px solid ${thirdly2}`,
        borderRadius: 8,
        ":hover": {
            opacity: 0.8,
            cursor: "pointer"
        }
    },
    '.role-item-icon': {
        width: 20,
        height: 20
    },
    '.role-content-title': {
        fontWeight: "bold",
    },
    '.role-content': {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        rowGap: 10
    },
    '.wrap-role-title': {
        display: "flex",
        flexDirection: "column",
        rowGap: 2,
        alignItems: "center",
        textAlign: "center"
    },
    '.role-sub-title': {

    },
    '.role-title': {
        fontWeight: "bold",
        fontSize: 20
    },
    '.role-icon': {
        width: 140,
        height: 140,
        marginTop: 10
    }
}));

export const MenuStyles = muiStyled(Menu)(({ }) => ({
}));